import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ref, reactive, onMounted} from 'vue'
import dayjs from 'dayjs'
import ProjectTemplate from '@/views/ViewsComponents/project/ProjectTemplate.vue'
import { useStore} from 'vuex'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  'POST/project_cost_time/owner': fetchList,
} = Api

const store = useStore()
let date = ref(dayjs().subtract(1, 'month').format('YYYY-MM-DD'))


let projectEle = ref()
let searchObj = reactive({
  date: date.value,
  userId: store.state.userId,
})
const searchHandle = (parmas: object) => {
  Object.assign(searchObj, parmas)
  projectEle.value.searchHandle(searchObj)
}
onMounted(() => {
  searchHandle({date: date.value})
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ProjectTemplate, {
      ref_key: "projectEle",
      ref: projectEle,
      searchObj: _unref(searchObj),
      tableFunc: _unref(fetchList)
    }, null, 8, ["searchObj", "tableFunc"])
  ]))
}
}

})